import Parse from 'parse';
import { Provider } from '@angular/core';
import { ParseResourceRepository } from '@telespot/infrastructure/parse';
import { RetrieveResourceChildrenQuery } from '@protocols/use-cases';

import { AssignedResourcesEffects, LOAD_RESOURCE_CHILDREN_QUERY } from '../../../effects/assigned-resources.effects';
import { AssignedResourcesPageState } from '../../../state/assigned-resources-page.state';
import { resourceStoreProviders } from '../../../providers/store.providers';
import { ResourceManagerFacade } from './resource-manager.facade';

/**
 * Providers for one resource manager instance. Spreads the resource-catalog
 * stack (left list), wires the lazy-load query (right list), and declares the
 * effects + facade. The shared `AssignedResourcesState` and `StagedResourcesState`
 * are NOT here — the outermost consumer provides + seeds them (so staged drafts
 * survive a manager unmount and nested managers see the same ledger), and
 * `RESOURCE_MANAGER_CONTAINER_ID` is provided per mount (see
 * `resource-manager.facade.ts`).
 */
export const resourceManagerProviders: Provider[] = [
  ...resourceStoreProviders,
  {
    provide: LOAD_RESOURCE_CHILDREN_QUERY,
    useFactory: () => new RetrieveResourceChildrenQuery(new ParseResourceRepository(Parse, { useMasterKey: false })),
  },
  AssignedResourcesEffects,
  AssignedResourcesPageState,
  ResourceManagerFacade,
];
